// src/components/NavigateMenu.tsx
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./NavigateMenu.css";
import { useMenu } from "../../hooks/useMenu";
import { LINKS } from "../../constants/menu-link.constants";
import type { NavigateMenuProps } from "../../models/menu.model";

const NavigateMenu: React.FC<NavigateMenuProps> = ({ onNavigate }) => {
  const { isOpen, toggle, select } = useMenu<number>({
    onSelect: onNavigate,
  });

  return (
    <>
      <div className="navigate-menu-wrapper">
        <button
          className="hamburger-button"
          onClick={toggle}
          aria-label="Toggle menu"
        >
          <div className="hamburger-line" />
          <div className="hamburger-line" />
          <div className="hamburger-line" />
        </button>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fullscreen-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="menu-items">
              {LINKS.map(({ label, page, url }) =>
                url ? (
                  <a
                    key={label}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={toggle}
                  >
                    {label}
                  </a>
                ) : (
                  <p key={page} onClick={() => select(page)}>
                    {label}
                  </p>
                )
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default NavigateMenu;
